(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-status.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-status.js');
"use strict";


const {
  format
} = svs.utils;
const {
  services,
  logger
} = svs.sportsbook.sbtech_api_impl;
let callCount = 0;
svs.sportsbook.sbtech_api_impl.fns.requests.sbtech_status = (post, _ref) => {
  let {
    getToken
  } = _ref;
  return () => {
    callCount++;
    const token = getToken();
    if (callCount > 1) {
      logger.info("whl.status already called. Token: ".concat(token, " count: ").concat(callCount));
    }
    services.accountBalance(accountBalanceResponse => {
      logger.info("whl.status token: ".concat(token));
      post({
        uid: Date.now().toString(),
        status: svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) ? 'real' : 'anon',
        message: '',
        token,
        balance: format.Currency(accountBalanceResponse)
      });
    });
  };
};

 })(window);